import type { JSX } from 'react'

export const PlaylistIcon = (): JSX.Element => (
  <use href='#playlistIcon' height='100%' width='100%' />
)
